import * as React from 'react'

import { Tabs, TabsList, TabsTrigger } from './tabs'

export interface SegmentedControlOption {
  value: string
  /** Label content — a string, or rich content (e.g. a label plus a tooltip icon). */
  label: React.ReactNode
}

/**
 * Segmented control — a bordered, transparent pill of mutually-exclusive options
 * with a brand-100 active fill. Built on the Tabs primitives; use for compact
 * single-select toggles such as Annual/Monthly or Best/Cheapest.
 *
 * Pass `className` to control width/flex: omit it to hug content, or use
 * `flex-1`/`w-full` to fill a row or container.
 */
export function SegmentedControl({
  value,
  onValueChange,
  options,
  className,
}: {
  value: string
  onValueChange: (value: string) => void
  options: SegmentedControlOption[]
  className?: string
}) {
  return (
    <Tabs value={value} onValueChange={onValueChange} className={className}>
      {/* Scrolls rather than clipping its last option when the row is narrower than the labels. */}
      <TabsList className="border-ink-100 no-scrollbar h-auto w-full justify-start gap-0 overflow-x-auto rounded-xl border bg-transparent p-1">
        {options.map((option) => (
          <TabsTrigger
            key={option.value}
            value={option.value}
            className="data-[state=active]:bg-brand-100 shrink-0 gap-1 rounded-lg border-none data-[state=active]:shadow-none"
          >
            {option.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}
